import { BaseService } from "./BaseService";

export const GrupoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('grupo/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos grupos:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('grupo/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos grupos:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('grupo', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de grupos:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`grupo/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de grupos:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`grupo/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de grupos:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('grupo/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir grupos:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('grupo/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar grupos:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('grupo/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar grupos:', error);
            return false;
        }
    }, 
}